import { Box } from 'app/design/primitives/box';
import Svg, { Path } from 'react-native-svg';

export function NotificationFavBadge({ color, backgroundColor }: { color: string; backgroundColor: string }) {
  return (
    <Box
      height={21}
      style={{ backgroundColor, borderRadius: 11, padding: 2, position: 'absolute', top: 36, left: 36 }}
      width={20}
    >
      <Svg height={17} viewBox="0 0 16 17" width={16}>
        <Path
          d="M3.14 9.91L7.27 13.77C7.47 13.96 7.74 14.05 8 14.05C8.26 14.05 8.52 13.96 8.73 13.77L12.85 9.91C13.5 9.31 13.86 8.48 13.87 7.59C13.88 6.74 13.55 5.93 12.94 5.31C12.34 4.7 11.53 4.36 10.67 4.35C9.98 4.35 9.32 4.56 8.77 4.97C8.46 5.19 8.2 5.46 8 5.76C7.79 5.46 7.53 5.19 7.23 4.97C6.67 4.56 6.01 4.35 5.32 4.35C4.46 4.36 3.66 4.7 3.05 5.31C2.45 5.93 2.12 6.74 2.12 7.59C2.13 8.48 2.49 9.31 3.14 9.91H3.14Z"
          fill={color}
        />
      </Svg>
    </Box>
  );
}
